export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="belongGold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#F3E5AB" />
        <stop offset="0.5" stopColor="#D4AF37" />
        <stop offset="1" stopColor="#9A8132" />
      </linearGradient>
    </defs>
    <g fill="url(#belongGold)">
      <path d="M24 7c3.6 4.6 5.2 8.7 5.2 13.2a5.2 5.2 0 1 1-10.4 0C18.8 15.7 20.4 11.6 24 7Z" />
      <path
        d="M24 7c3.6 4.6 5.2 8.7 5.2 13.2a5.2 5.2 0 1 1-10.4 0C18.8 15.7 20.4 11.6 24 7Z"
        transform="rotate(-38 24 27)"
        opacity="0.65"
      />
      <path
        d="M24 7c3.6 4.6 5.2 8.7 5.2 13.2a5.2 5.2 0 1 1-10.4 0C18.8 15.7 20.4 11.6 24 7Z"
        transform="rotate(38 24 27)"
        opacity="0.65"
      />
      <path d="M8.5 30.5c4.2 5.2 9.4 8 15.5 8s11.3-2.8 15.5-8c-1.2 6.8-7.2 11-15.5 11s-14.3-4.2-15.5-11Z" />
    </g>
  </svg>
);

export const LogoLockup = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark className={compact ? "w-7 h-7" : "w-9 h-9"} />
    <span className="flex flex-col leading-none">
      <span
        className={`font-display font-medium tracking-[0.28em] text-amber-100 ${
          compact ? "text-base" : "text-lg"
        }`}
      >
        BELONG
      </span>
      <span className="font-mono-alt text-[8px] uppercase tracking-[0.4em] text-amber-500/80 mt-1">
        Salon & Spa
      </span>
    </span>
  </span>
);
